import * as React from 'react';
import { FirestoreError } from 'firebase/firestore';

// @ld
import useGetItem from 'api/utils/use-get-item';

import { PROFILES, IProfileRead } from '@ld/utils';
// @custom

const ProfileContext = React.createContext<{
  profileId: string;
  profile?: IProfileRead;
  error: FirestoreError | null;
  setProfileId: (profileId: string) => void;
}>({ profileId: '', error: null, setProfileId: () => null });

export const ProfileProvider = ({ children }: { children: React.ReactNode }) => {
  const [profileId, setProfileId] = React.useState('');

  const { data: profile, error } = useGetItem<IProfileRead>({
    collection: PROFILES,
    id: profileId,
    enabled: !!profileId
  });

  return (
    <ProfileContext.Provider value={{ profile, profileId, error, setProfileId }}>
      {children}
    </ProfileContext.Provider>
  );
};

ProfileContext.displayName = 'ProfileContext';

export default ProfileContext;
